import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';
import { Check, X } from 'lucide-react';

export function OversightColumn({ title, items, positive, testId }) {
    const anim = positive ? staggeredFadeIn(0.15) : fadeUp;
    return (
        <motion.div
            {...anim}
            className={positive
                ? 'bg-white border-2 border-gold-400 rounded-sm overflow-hidden shadow-md'
                : 'bg-white border border-gray-200 rounded-sm overflow-hidden'}
            data-testid={testId}
        >
            <div className={positive ? 'bg-navy-900 px-8 py-4' : 'bg-gray-100 px-8 py-4 border-b border-gray-200'}>
                <h3 className={`font-montserrat font-bold text-base ${positive ? 'text-white' : 'text-[#6B7280]'}`}>{title}</h3>
            </div>
            <ul className="px-8 py-6 space-y-4">
                {items.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                        {positive
                            ? <Check size={16} className="text-gold-400 flex-shrink-0 mt-1" strokeWidth={2} />
                            : <X size={16} className="text-red-400 flex-shrink-0 mt-1" strokeWidth={2} />}
                        <span className={positive ? 'text-navy-900 text-sm leading-relaxed font-medium' : 'text-[#6B7280] text-sm leading-relaxed'}>{item}</span>
                    </li>
                ))}
            </ul>
        </motion.div>
    );
}
